import React, { memo } from 'react';

import { FileInput } from './FileInput/FileInput';
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import s from './XLSXInput.module.scss';
import { IconButton } from '@material-ui/core';

type FileInputProps = {
  onFilesSelected: (files: File[]) => void;
  onRemoveFile: () => void;
  file?: File;
};

const XLSXInput = ({ onFilesSelected, onRemoveFile, file }: FileInputProps) => {

  const handleRemoveFile = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onRemoveFile();
  };

  return (
    <div className={s.xlsxInputContainer}>
      <FileInput onFilesSelected={onFilesSelected} accept=".xlsx" multiple={false} file={file}>
        <div className={s.uploadInfoContainer}>
          <div className={s.uploadInfoTitleContainer}>
            {!file ? (
              <span className={s.uploadInfoTitle}>
                Drag & Drop or <span className={s.uploadInfoTitleLink}>Upload</span> a <span className={s.uploadInfoTitleFormat}>CSV</span> or <span className={s.uploadInfoTitleFormat}>XSLX</span> file with order details to update tracking information
              </span>
            ) : (
              <>
                <div className={s.uploadInfoTitleFile}>
                  <InsertDriveFileIcon className={s.iconFile} />
                  <span className={s.fileName}>{file?.name}</span>
                  <IconButton onClick={handleRemoveFile} >
                    <DeleteOutlineIcon className={s.iconDeleteFile} />
                  </IconButton>
                </div>
              </>
            )}
          </div>

        </div>
      </FileInput>
    </div>
  );
};

export default memo(XLSXInput);
